var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { useRef } from "react";
import classNames from "classnames";
import Mask from "../Mask";
// import Icon from '../icon'
import { mergeProps } from "../../utils/with-default-props";
var classPrefix = "iweb-toast";
var defaultProps = {
  maskClickable: true
};
// @TODO: handle icons
export var Toast = function (p) {
  var props = mergeProps(defaultProps, p);
  var content = props.content,
    title = props.title,
    maskStyle = props.maskStyle,
    maskClassName = props.maskClassName,
    maskClickable = props.maskClickable,
    visible = props.visible;
  var ref = useRef(null);
  // const iconElement = () => {
  //     if (icon === null || icon === undefined) return null
  //     switch(icon) {
  //         case 'info':
  //             return <Icon type="notice" size="large" className={`${classPrefix}-icon-${icon}`} />
  //         case 'warning':
  //             return <Icon type="warn" size="large"  className={`${classPrefix}-icon-${icon}`} />
  //         case 'error':
  //             return <Icon type="error" size="large" className={`${classPrefix}-icon-${icon}`} />
  //         case 'success':
  //             return <Icon type="success" size="large" className={`${classPrefix}-icon-${icon}`} />
  //         default:
  //             return null
  //     }
  // }
  return /*#__PURE__*/React.createElement(Mask, {
    visible: visible,
    destroyOnClose: true,
    opacity: 0,
    disableBodyScroll: !maskClickable,
    style: __assign({
      pointerEvents: maskClickable ? "none" : "all"
    }, maskStyle),
    className: classNames(classPrefix + "-mask", maskClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(classPrefix + "-container")
  }, title && /*#__PURE__*/React.createElement("h4", {
    className: classNames(classPrefix + "-title")
  }, title), /*#__PURE__*/React.createElement("div", {
    className: classNames(classPrefix + "-wrap"),
    ref: ref
  }, content)));
};